import React from "react";
import { api } from "api";
import { icons } from "icons";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { ListadoAccion } from "Utils/ListadoAccion";
import { DetalleAccion } from "Utils/DetalleAccion";
import { formatoCantidad } from "./CamposSalidaProductos";
import { validate, validators } from "validate-redux-form";
import {
    renderTextArea,
    renderSearchSelect,
} from "Utils/renderField/renderField";
import {
    buscar,
    formatoAcciones,
    formatoExistencia,
    formatoExistenciaFracción,
    formatoInventario,
    formatoInventarioFraccion,
    formatoNombre,
    formatoProducto,
    formatoCodigo
} from "Utils/CamposComunes";

export const listaDestinoSalida = [];

const Form = (props) => {
    //  State
    const { loader, data, seleccionados, page, ver_buscador, conf_tipo_negocio} = props;
    //   Bind
    const { handleSubmit, sortChange, cambio_buscador, listar, quitar } = props;
    const llavesListado = [
        {
            nombre: "codigos_barras",
            sort: true,
            caption: "Código de Barras",
            format: formatoCodigo,
            align: "left",
        },
        {
            nombre: "producto__nombre",
            sort: true,
            caption: "Nombre",
            format: formatoNombre,
            align: "left",
        },
        {
            nombre: "inventario",
            sort: false,
            caption: "Existencias",
            format: conf_tipo_negocio === "Telas" 
                            ? formatoExistenciaFracción 
                            : formatoExistencia,
            align: "right",
        },
        {
            nombre: "acciones",
            sort: false,
            caption: "Acciones",
            format: formatoAcciones(props),
            align: "center",
            width: "90px",
        },
    ];

    const llavesDetalle = [
        { caption: "Producto", nombre: "producto", format: formatoProducto },
        {
            caption: "Existencias",
            nombre: "existencias",
            format: conf_tipo_negocio === "Telas" 
                            ? formatoInventarioFraccion 
                            : formatoInventario,
            width: "120px",
            align: "right",
        },
        {
            caption: "Cantidad",
            nombre: "cantidad",
            format: formatoCantidad(props),
            width: "250px",
        },
    ];

    const getDestinos = (search) => {
        return api
            .get("destino_salida_producto", { search })
            .catch(() => {})
            .then((data) => {
                data.results.forEach((item) => {
                    if (!_.find(listaDestinoSalida, { id: item.id }))
                        listaDestinoSalida.push(item);
                });
                return { options: listaDestinoSalida };
            });
    };

    return (
        <form onSubmit={handleSubmit} className="row form-group">
            <div className="col-12 mb">
                <div className="grid-container pl-5 pr-5 pt-2 pb-2 d-flex flex-column">
                    <div className="d-flex flex-column bodega-info-adicional mb-1 mb-md-4">
                        <label htmlFor="destino">Destino:</label>
                        <div
                            className="d-flex flex-column flex-md-row pr-0"
                            style={{ maxWidth: "650px" }}
                        >
                            <div className="d-flex flex-column w-100">
                                <Field
                                    name="destino"
                                    component={renderSearchSelect}
                                    loadOptions={getDestinos}
                                    labelKey="nombre"
                                    valueKey="id"
                                    className="form-control"
                                />
                            </div>
                            <small className="d-inline-block d-md-none mt-1 mb-1">
                                No encuentras el destino
                            </small>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    props.abrirDestino();
                                }}
                                style={{ height: "fit-content" }}
                                className="btn btn-secondary ml-0 mr-0 ml-md-3 mr-md-3"
                            >
                                <i className="fa fa-plus" /> Crear Destino
                            </button>
                        </div>
                    </div>
                    <div className="form-group bodega-info-adicional">
                        <label htmlFor="concepto">
                            Ingrese un número de documento, anotaciones u otros
                            comentarios pertinentes
                        </label>
                        <Field
                            name="concepto"
                            rows={2}
                            component={renderTextArea}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
            <div className="slide-container row" style={{ margin: "0" }}>
                <div
                    className={`col-lg-6 col-md-12 pr-md-0 ${
                        ver_buscador ? "form-activo" : ""
                    } slide `}
                >
                    <ListadoAccion
                        buscar={buscar(props)}
                        loader={loader}
                        llaves={llavesListado}
                        data={data}
                        listar={listar}
                        sortChange={sortChange}
                        titulo={"Listado de Productos"}
                        page={page}
                    />
                    <div className="d-lg-none d-xl-none grid-container align-items-center mt0 padding-10 d-flex justify-content-around flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row">
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => {
                                cambio_buscador();
                            }}
                        >
                            <img src={icons.cancelar} alt="" /> Cancelar
                        </button>
                    </div>
                </div>
                <div
                    className={`col-lg-6 col-md-12 ${
                        !ver_buscador ? "form-activo" : ""
                    } form-trasero`}
                >
                    <DetalleAccion
                        data={seleccionados}
                        titulo={"Lista de salida de producto"}
                        llaves={llavesDetalle}
                        loader={loader}
                        agregar={cambio_buscador}
                        quitar={quitar}
                    />
                    <div
                        style={{
                            borderRadius: "0",
                            padding: "4px 2px 2px 2px",
                            borderTop: "none",
                        }}
                        className="grid-container bg-primary mt0"
                    >
                        <div
                            className="d-flex justify-content-around align-items-center padding-10 flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row"
                            style={{ backgroundColor: "#FFF" }}
                        >
                            {/* <button className="d-lg-none d-xl-none btn btn-outline-primary" type="button" onClick={() => {cambio_buscador()}}>Agregar Producto</button> */}
                            <div className="align-items-center mt0 padding-10 d-flex justify-content-around flex-row flex-sm-row flex-md-row flex-lg-row flex-xl-row">
                                <Link
                                    className="btn btn-tertiary mr-1"
                                    to={"/bodega"}
                                >
                                    <img src={icons.cancelar} alt="" />
                                    Cancelar
                                </Link>
                                <button
                                    disabled={loader}
                                    className="btn btn-primary pull-right ml-1"
                                    type="submit"
                                >
                                    <i className="fa fa-check mr"></i>
                                    Finalizar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

const SalidaProductoForm = reduxForm({
    // a unique name for the form
    form: "SalidaProductoForm",
    validate: (data) => {
        return validate(data, {
            destino: validators.exists()("Campo requerido"),
        });
    },
})(Form);

export default SalidaProductoForm;
